import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { LargeButton, ButtonType, Button, GreenButton } from '@checkmarx/cx-ui';
import { Link } from 'react-router-dom';
import { Alert } from '../../common/icons';
@inject('translationsStore') @observer
export default class PasswordExpiredForm extends Component {
    
    render() {
        return (
            <form>
                <div>
                    <span style={{ color: 'red', fontSize: '14px' }}>
                        <Alert />{' '}
                        <span>{this.props.translationsStore.translate('PASSWORD_EXPIRED')}</span>
                    </span>
                </div>
                <div>
                    <Link to="/changepassword">
                        <LargeButton
                            type="submit"
                            id="btnOk"
                            text={this.props.translationsStore.translate('OK')}
                            style={{ marginLeft: '55px', marginTop: '30px', width: '100px' }} />
                    </Link>
                    <Link to="/">
                        <LargeButton
                            id="btnCancel"
                            text={this.props.translationsStore.translate('CANCEL')}
                            style={{ marginTop: '30px', marginLeft: '15px', width: '100px' }}
                        />
                    </Link>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/account/passwordExpired/index.jsx